import React from 'react';
import { ToastContainer, toast, style } from 'react-toastify';
import ToastrLevelsEnum from '../enums/toastrLevelsEnum';
import PortalToastrContent from '../../components/portal/portalToastrContent';

style({
    width: '380px',
    BOTTOM_RIGHT: {right:'2em', bottom:'1em'}
});

class ToastrService {
    
    getToastrContentComponent(toastrMessage,moreDetails,iconClassName,maxNumberOfCharacters,toastrClassname,partialFailure){
        return <PortalToastrContent iconClass={iconClassName} message={toastrMessage} moreDetails={moreDetails} 
                              maxNumberOfCharacters={maxNumberOfCharacters} toastrClassname={toastrClassname}/>;
    }
  
    triggerToastr(toastrInfo){
      
        switch(toastrInfo.level) {
        case ToastrLevelsEnum.SUCCESS:
            toast(this.getToastrContentComponent(toastrInfo.message,toastrInfo.moreInfo,'icon-v',100,'success-toastr'),
                {position: toast.POSITION.BOTTOM_RIGHT, autoClose: toastrInfo.autoClose !== undefined ? toastrInfo.autoClose : true});
            break;
        case ToastrLevelsEnum.ERROR:
            toast.error(this.getToastrContentComponent(toastrInfo.message,toastrInfo.moreInfo,'failure',100,'error-toastr'),
            {position: toast.POSITION.BOTTOM_RIGHT, autoClose: toastrInfo.autoClose !== undefined ? toastrInfo.autoClose : true});
            break;
        case ToastrLevelsEnum.INFO:
            toast.info(toastrInfo.message);
            break;
        case ToastrLevelsEnum.WARN:
            toast.warn(toastrInfo.message);
            break;
        default:
          toast(toastrInfo.message);
      };
    }
}

export default new ToastrService();


// WEBPACK FOOTER //
// ./src/services/ui/toastrService.js